/** Minimal route-level Suspense fallback — white bg, indigo V, fast paint. */
const LoadingScreen = () => (
  <main className="flex min-h-screen flex-col items-center justify-center gap-3 bg-white">
    <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-indigo-600">
      <span className="text-xl font-bold leading-none text-white">V</span>
    </div>
    <p className="text-sm font-medium text-slate-600">Loading...</p>
  </main>
);

export default LoadingScreen;
